import { Tab } from '../../../../../modals/modifier/ModifierModal';

export default {
  title: 'Nieuwe optie',
  tabs: {
    [Tab.General]: 'Algemeen',
    [Tab.NutritionInfo]: 'Voedingsinfo',
  },
  form: {
    modifier_groups: {
      label: 'Behoort tot optiegroepen',
    },
    name: {
      label: 'Naam',
      placeholder: 'Ketchup',
    },
    external_id: {
      label: '{{integration}} ref',
      placeholder: 'bijv. HubRise SKU-referentie',
      read_only_hint:
        'Bewerkbaar alleen als een HubRise-integratie is verbonden en menusynchronisatie is uitgeschakeld.',
    },
    price: {
      label: 'Basisprijs',
      placeholder: 'Optioneel',
    },
    is_available: {
      label: 'Op voorraad',
    },
    is_visible: {
      label: 'Zichtbaar',
      title: 'Zichtbaar op menu',
      subtitle_on: 'Klanten kunnen deze optie zien',
      subtitle_off: 'Verborgen voor alle klanten',
    },
    is_available_for_pickup: {
      label: 'Beschikbaar voor afhalen',
      subtitle_on: 'Klanten kunnen het bestellen voor afhalen',
      subtitle_off: 'Verborgen op afhaalmenu',
    },
    is_available_for_delivery: {
      label: 'Beschikbaar voor bezorging',
      subtitle_on: 'Klanten kunnen het bestellen voor bezorging',
      subtitle_off: 'Verborgen op bezorgmenu',
    },
  },
  availability: {
    title: 'Beschikbaarheid',
    helper:
      'Zichtbaarheid is de hoofdschakelaar. Schakel een kanaal uit om deze optie te verbergen voor afhaal- of bezorgklanten zonder het van het menu te verwijderen.',
    status: {
      both: 'Beide kanalen',
      pickup_only: 'Alleen afhalen',
      delivery_only: 'Alleen bezorging',
      hidden: 'Verborgen',
      no_channels: 'Geen kanalen',
    },
    warning: {
      no_channels:
        'Deze optie is zichtbaar maar op geen enkel kanaal beschikbaar — klanten kunnen het niet selecteren.',
    },
    placeholder: '—',
    list_badge: {
      pickup_only: 'Alleen afhalen',
      delivery_only: 'Alleen bezorging',
      no_channels: 'Geen kanalen',
    },
  },
  buttons: {
    save: 'Opslaan',
  },
  toasts: {
    changes_got_saved: 'Wijzigingen succesvol opgeslagen!',
  },
};
